export const LCL_CONSTANTS = {
    GET_LCL_SUPPLIER: ':api/lcl/supplier',
    CREATE_LCL_SUPPLIER: ':api/lcl/supplier'
};
